import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import { withTheme } from 'styled-components';
import CategoryButtonList from './CategoryButtonList';
import CategoryImage from './CategoryImage';
import ImageText from '../../common/imageText';
import '../styles.css';

const Shrink = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={500}
    classNames="shrink"
  >
    {children}
  </CSSTransition>
);

const Grow = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={500}
    classNames="grow"
  >
    {children}
  </CSSTransition>
);

const Fade = ({ children, ...props }) => (
  <CSSTransition
    {...props}
    timeout={3000}
    classNames="fade"
  >
    {children}
  </CSSTransition>
);

class Category extends Component {
  lgBkg = {
      id: 'lgBkg',
      src: this.props.theme.menu_box_large,
      top: 46,
      left: 0,
      width: 563,
      height: 522
  };
  smBkg = {
      id: 'smBkg',
      src: this.props.theme.menu_box_small,
      width: 222,
      height: 222
  };
  shrinkBkg = {
      id: 'shrinkBkg',
      src: this.props.theme.menu_box_small,
  };
  growBkg = {
      id: 'growBkg',
      src: this.props.theme.menu_box_large,
  };
  imageButtonsList = {
    top: 58
  };
  hl = {
    id: 'hl',
    src: this.props.theme.menu_highlight
  }
  uh = {
    id: 'uh',
    src: null
  }

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
      {this.props.currentHighlight && (
        <div className="hilite-category">
          <ImageText {...this.lgBkg} />
          <Fade in={this.props.shrinkGrow} >
            <div className={`fade-${this.props.hlState}`}>
              <ImageText {...this.props.largeHeader} />
              <CategoryButtonList {...this.imageButtonsList} imageButtons={this.props.serviceLinks}
                                      hl={this.hl} uh={this.uh} disabled={this.props.disabled}/>
            </div>
          </Fade>
        </div>
      )}
      {!this.props.currentHighlight && this.props.shrinkMe && !this.props.growMe && (
        <Shrink in={this.props.shrinkGrow} >
          <div className='hilite-category hilite-category-grow'>
            <CategoryImage {...this.shrinkBkg} />
          </div>
        </Shrink>
      )}
      {!this.props.currentHighlight && !this.props.shrinkMe && this.props.growMe && (
        <Grow in={this.props.shrinkGrow} >
          <div className='un-highlight-category'>
            <CategoryImage {...this.growBkg} />
          </div>
        </Grow>
      )}
      {!this.props.currentHighlight && !this.props.shrinkMe && !this.props.growMe && (
        <div className='un-highlight-category'>
          <ImageText {...this.smBkg} />
          <ImageText {...this.props.smallHeader} />
        </div>
      )}
      </div>
    );
  }
}

export default withTheme(Category);
